import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {SharedModule} from "../../shared/shared.module";
import {TaxpayersSearchComponent} from "./taxpayers-search.component";
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TranslocoModule,
  ],
  exports: [
    TaxpayersSearchComponent,
  ],
  declarations: [
    TaxpayersSearchComponent,
  ],
  providers: [{ provide: TRANSLOCO_SCOPE, useValue: { scope: 'taxpayers-search', alias: 'taxpayersSearch' } }],
})
export class TaxpayersSearchModule { }
